import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../../../components";
import { useSupportedDevice } from "../../../../../context/SupportedDeviceContext";

import { useEffect, useState } from "react";
import styles from "./style.module.scss";
const TopArea = () => {
  const { t } = useTranslation();
  const { setShowModal } = useSupportedDevice();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const scrollToElementById = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });
  return (
    <div
      className={styles.topArea}
      style={{
        backgroundImage:
          windowWidth <= 768
            ? `url('/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/home/home_mobile_bg.png')`
            : "",
      }}
    >
      <div className={styles.topContentContainer}>
        <div
          className={
            windowWidth <= 768 ? styles.mobileBtnGroup : styles.btnGroup
          }
        >
          <div
            className={styles.slogan1}
            dangerouslySetInnerHTML={{ __html: t("home.2esim.slogan1") }}
          />
          <div
            className={styles.slogan2}
            dangerouslySetInnerHTML={{ __html: t("home.2esim.slogan2") }}
          />
          <span className={styles.slogan3}>{t("home.2esim.slogan3")}</span>
          <div className={styles.btnContainer}>
            <div className={styles.deviceContainer}>
              <CustomButton
                style={{
                  borderColor: windowWidth <= 768 ? "var(--primary200)" : "",
                  color: windowWidth <= 768 ? "var(--primary200)" : "",
                }}
                onClick={() => {
                  scrollToElementById("homeStepArea");
                }}
              >
                {t("home.simple.3steps")}
              </CustomButton>
              <div
                className={styles.linkText}
                onClick={() => setShowModal(true)}
              >
                {t("normal.check.avaliable.device")}
              </div>
            </div>
            <CustomButton
              style={{
                backgroundColor: windowWidth <= 768 ? "var(--primary200)" : "",
                color: windowWidth <= 768 ? "var(--primary600)" : "",
              }}
              type="primary"
              onClick={() => {
                scrollToElementById("homeProductArea");
              }}
            >
              {t("normal.buy.now")}
            </CustomButton>
          </div>
        </div>
        {windowWidth <= 768 ? (
          ""
        ) : (
          <Image
            alt={`${process.env.REACT_APP_PROD_NAME_DISPLAY}-home`}
            src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/home/home_fly_bg.png`}
            preview={false}
            className={styles.bigLogo}
          />
        )}
      </div>
    </div>
  );
};

export default TopArea;
